import { render } from "./Forgot.vue?vue&type=template&id=c7d093a8"
import script from "./Forgot.vue?vue&type=script&lang=js"
export * from "./Forgot.vue?vue&type=script&lang=js"

import exportComponent from "/Users/avinduhewa/Documents/Projects/bokaklip/payl-firebase/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__